import { type FC } from 'react';
import { Checkbox, type CheckboxProps, Help, type HelpProps } from '@direct-frontend/components';

export type AutoCollectionFeedCheckboxProps = Omit<CheckboxProps, 'children' | 'help' | 'size'>;

const AutoCollectionFeedHelp: FC<HelpProps> = (props) => (
    <Help {...props} maxWidth="360">
        Информация о странице коллекции попадет в фид Яндекс Директа. Вы сможете продвигать коллекцию в рекламных
        кампаниях и вести покупателей на неё.
    </Help>
);

export const AutoCollectionFeedCheckbox: FC<AutoCollectionFeedCheckboxProps> = (props) => (
    <Checkbox {...props} size="m" help={AutoCollectionFeedHelp}>
        Включать в фид для Яндекс Директа
    </Checkbox>
);
